import { MeetingSidePanelConfiguration } from "../components/ui/meeting-side-panel/meeting-side-panel-configuration.jsx";

export const MeetingSidePanelConfigurationPage = () => (
  <div className="flex h-full w-full p-6">
    <div className="w-full max-w-md rounded-lg bg-white p-8">
      <h1 className="mb-6 text-center text-2xl font-semibold text-gray-900">
        Configure Meeting Side Panel
      </h1>
      <MeetingSidePanelConfiguration />
    </div>
  </div>
);
